/**
 * @override
 * 自定义积木，要采用统一样式，必须在定义积木样式，
 * 设置output:'String/Number/Boolean/...'
 *
 */
import Blockly from 'blockly'

// 默认的机器人robot
Blockly.Blocks['gta_robot'] = {
  init: function() {
    this.appendDummyInput().appendField('robot')
    this.setOutput(true)
    this.setStyle('event_blocks')
    this.setTooltip('')
    this.setInputsInline(true)
    this.setHelpUrl(Blockly.Msg['gta_robot'])
  },
}
Blockly.Python['gta_robot'] = function(block) {
  var code = 'robot'
  return [code, Blockly.Python.ORDER_NONE]
}

// define a robot
Blockly.Blocks['gta_define_robot_B'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('请连接一个robot ID')
      .appendField(new Blockly.FieldTextInput(''), 'NAME')
    this.setStyle('event_blocks')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip(
      '在同个局域网内，搜寻STA模式下的机器设备，并建立连接。参数：string类型，指代机器设备的名称（ID）默认值为 "robot"。返回无。'
    )
    this.setHelpUrl(Blockly.Msg['gta_define_robot_B'])
  },
}

Blockly.Python['gta_define_robot_B'] = function(block) {
  var robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var name = block.getFieldValue('NAME')
  var code = `${robot} = RobotX('${name}')\n`
  return code
}

// 断开机器人连接
Blockly.Blocks['gta_robot_B_close'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField('断开连接')
    this.setStyle('event_blocks')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip('断开机器人连接。无参数。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_B_close'])
  },
}
Blockly.Python['gta_robot_B_close'] = function(block) {
  var robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var name = block.getFieldValue('NAME')
  var code = `${robot}.close()\n`
  return code
}

// 获取机器人电量
Blockly.Blocks['gta_robot_B_get_battery'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 获取电量')
    this.setStyle('event_blocks')
    this.setOutput(true)
    this.setTooltip('获取机器人电量。无参数。返回：0~100;返回剩余电量百分比。')
    this.setHelpUrl(Blockly.Msg['gta_robot_B_get_battery'])
  },
}
Blockly.Python['gta_robot_B_get_battery'] = function(block) {
  var robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var name = block.getFieldValue('NAME')
  var code = `${robot}.get_battery()`
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}

// 获取机器人序列号
Blockly.Blocks['gta_robot_B_get_sn'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 获取序列号')
    this.setStyle('event_blocks')
    this.setOutput(true)
    this.setTooltip('获取机器人序列号。无参数。返回：SN字符串。')
    this.setHelpUrl(Blockly.Msg['gta_robot_B_get_sn'])
  },
}
Blockly.Python['gta_robot_B_get_sn'] = function(block) {
  var robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var name = block.getFieldValue('NAME')
  var code = `${robot}.get_sn()`
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}

// 获取机器人固件版本号
Blockly.Blocks['gta_robot_B_get_version'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 获取固件版本号')
    this.setStyle('event_blocks')
    this.setOutput(true)
    this.setTooltip('获取机器人固件版本号。无参数。返回：固件版本号。')
    this.setHelpUrl(Blockly.Msg['gta_robot_B_get_version'])
  },
}

Blockly.Python['gta_robot_B_get_version'] = function(block) {
  var robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var code = `${robot}.get_version()`
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}

/**
 * 轮Chassis模块
 * */

//  设置麦轮速度
Blockly.Blocks['gta_robot_B_drive_wheels'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(' 麦轮速度：')
      .appendField(' 左前轮 ')
      .appendField(new Blockly.FieldNumber(0, -100, 100, 1), 'lf')
      .appendField(' 左后轮 ')
      .appendField(new Blockly.FieldNumber(0, -100, 100, 1), 'lb')
      .appendField(' 右前轮 ')
      .appendField(new Blockly.FieldNumber(0, -100, 100, 1), 'rf')
      .appendField(' 右后轮 ')
      .appendField(new Blockly.FieldNumber(0, -100, 100, 1), 'rb')
      .appendField('  ')
      .appendField(new Blockly.FieldNumber(10), 'timeout')
      .appendField('秒停止运动')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('drive_blocks')
    this.setTooltip(
      '设置不同速度可以实现前进、后退、旋转、平移等运动。参数：左前轮速度、左后轮速度、右前轮速度、右后轮速度、几秒后停止运动。返回：设置成功返回True，失败返回False。'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_drive_wheels'])
  },
}

Blockly.Python['gta_robot_B_drive_wheels'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  let lf = block.getFieldValue('lf')
  let lb = block.getFieldValue('lb')
  let rf = block.getFieldValue('rf')
  let rb = block.getFieldValue('rb')
  let timeout = block.getFieldValue('timeout')

  var code = `${robot}.chassis.drive_wheels(lf=${lf}, lb=${lb}, rf=${rf}, rb=${rb}, timeout=${timeout})\n`
  return code
}

// 设置路径规划。
Blockly.Blocks['gta_robot_B_chassis_move'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('运动路径：')
      .appendField('  向X轴运动')
      .appendField(new Blockly.FieldNumber(0, -160, 160, 1), 'axiosX')
      .appendField('厘米  向Y轴运动')
      .appendField(new Blockly.FieldNumber(0, -160, 160, 1), 'axiosY')
      .appendField('厘米  旋转')
      .appendField(new Blockly.FieldNumber(0, -180, 180, 1), 'angle')
      .appendField('角度')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('drive_blocks')
    this.setTooltip(
      '设置路径规划。当前位置为原点，向X轴运动（0）厘米，向Y轴运动（0）厘米，然后旋转（0）角度。参数：1.向X轴运动（0）厘米,整数类型,-160~160;2.向Y轴运动厘米,整数类型,-160~160;3.旋转（）角度,整数类型,-180~180。无返回。'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_chassis_move'])
  },
}

Blockly.Python['gta_robot_B_chassis_move'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  let axiosX = block.getFieldValue('axiosX')
  let axiosY = block.getFieldValue('axiosY')
  let angle = block.getFieldValue('angle')

  var code = `${robot}.chassis.move(x=${axiosX},y=${axiosY}, a=${angle})\n`
  return code
}

/**
 * 臂Arm模块
 * */

// 机械臂回到初始位置
Blockly.Blocks['gta_robot_B_arm_recenter'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 机械臂回到初始位置')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip(
      '机械臂回到初始位置;bool ：回中完成返回True，否则返回False;初始位置坐标点为（12，15）。'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_arm_recenter'])
  },
}

Blockly.Python['gta_robot_B_arm_recenter'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var code = `${robot}.arm.recenter()\n`
  return code
}
// 移动机械臂到绝对位置：X（）Y（）
Blockly.Blocks['gta_robot_B_arm_move_to'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(' 机械臂移动到  x')
      .appendField(new Blockly.FieldNumber(12, 12, 18, 1), 'axiosX')
      .appendField('  y')
      .appendField(new Blockly.FieldNumber(15, 3, 19, 1), 'axiosY')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip(
      '移动机械臂到绝对位置：X（）Y（）。X轴取值范围为12~18的整数值；Y轴取值范围为3~19的整数值；但是由于机器臂的动作的局限，机械臂移动不到在X、Y活动区间的一些的位置，比如机器臂可能移动不到（13,18）位置。'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_arm_move_to'])
  },
}

Blockly.Python['gta_robot_B_arm_move_to'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  let axiosX = block.getFieldValue('axiosX')
  let axiosY = block.getFieldValue('axiosY')

  var code = `${robot}.arm.move_to(x=${axiosX},y=${axiosY})\n`
  return code
}

/**
 * 夹Gripper模块
 * */

//  获取机械手状态
Blockly.Blocks['gta_robot_B_gripper_get_status'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 获取机械手状态')
    this.setInputsInline(true)
    this.setOutput(true)
    this.setStyle('posture_blocks')
    this.setTooltip(
      '获取机械手状态。返回：a.int ：0:完全张开, 1:完全闭合, 2:中间状态;b. bool ：False：异常。'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_gripper_get_status'])
  },
}

Blockly.Python['gta_robot_B_gripper_get_status'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )

  var code = `${robot}.gripper.get_status()`
  return [code, Blockly.Python.ORDER_NONE]
}

// 机械手闭合
Blockly.Blocks['gta_robot_B_gripper_close'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 机械手闭合')

    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip(
      '机械手闭合。参数：无。返回bool ：机械手关闭为True，否则为False'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_gripper_close'])
  },
}

Blockly.Python['gta_robot_B_gripper_close'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )

  var code = `${robot}.gripper.close()\n`
  return code
}

// 机械手打开
Blockly.Blocks['gta_robot_B_gripper_open'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 机械手打开')

    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip(
      '机械手打开。参数：无。返回bool ：机械手打开为True，否则为False'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_gripper_open'])
  },
}

Blockly.Python['gta_robot_B_gripper_open'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )

  var code = `${robot}.gripper.open()\n`
  return code
}

/**
 * 舵机Servo模块
 * */

//  获取舵机角度值
Blockly.Blocks['gta_robot_B_servo_get_angle'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(' 获取舵机角度值')
      .appendField(
        new Blockly.FieldDropdown([
          ['左舵机', '0'],
          ['右舵机', '1'],
        ]),
        'angle'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip('获取舵机角度值。返回： int ：舵机角度')
    this.setHelpUrl(Blockly.Msg['gta_robot_B_servo_get_angle'])
  },
}

Blockly.Python['gta_robot_B_servo_get_angle'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var angle = block.getFieldValue('angle')
  var code = `${robot}.servo.get_angle(id=${angle})`
  return code
}

//  舵机旋转
Blockly.Blocks['gta_robot_B_servo_move_to'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(' 舵机旋转')
      .appendField(
        new Blockly.FieldDropdown([
          ['左舵机：(85,180]', '0'],
          ['右舵机：[0,100)', '1'],
        ]),
        'servo'
      )
      .appendField(' 旋转')
      .appendField(new Blockly.FieldNumber(0, 0, 180, 1), 'angle')
      .appendField(' °')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip(
      '旋转舵机。参数：a.左舵机：旋转范围范围(85,180];b.右舵机，范围0~110； 返回bool ：移动成功返回 True, 否则返回 False'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_servo_move_to'])
  },
}

Blockly.Python['gta_robot_B_servo_move_to'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var servo = block.getFieldValue('servo')
  var angle = block.getFieldValue('angle')
  var code = `${robot}.servo.move_to(id=${servo},angle=${angle})\n`
  return code
}

/**
 * 灯LED模块 -舍弃
 * */

//  开启RGB灯光
Blockly.Blocks['gta_robot_B_led_set_led'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('开启RGB灯光：')
      .appendField(new Blockly.FieldNumber(0, 0, 255, 1), 'RED')
      .appendField(new Blockly.FieldNumber(0, 0, 255, 1), 'GREEN')
      .appendField(new Blockly.FieldNumber(0, 0, 255, 1), 'BLUE')
    this.setStyle('light_blocks')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip(
      '开启RGB灯光。返回bool ： 设置成功返回 True, 设置失败返回 False'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_led_set_led'])
  },
}

Blockly.Python['gta_robot_B_led_set_led'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var number_red = block.getFieldValue('RED')
  var number_green = block.getFieldValue('GREEN')
  var number_blue = block.getFieldValue('BLUE')
  var code = `${robot}.led.set_led(color=(${number_red},${number_green},${number_blue}))\n`
  return code
}

/**
 * 摄像头Camera模块
 * */

// 打开摄像头-功能：在主程序运行过程中开启服务，并持续显示图像
Blockly.Blocks['gta_robot_B_display_video'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField('打开摄像头')
    this.setStyle('robot_B_camera')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip('主程序运行过程中开启服务，持续显示图像。')
    this.setHelpUrl(Blockly.Msg['gta_robot_B_display_video'])
  },
}

Blockly.Python['gta_robot_B_display_video'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var code = `${robot}.display_video()\n`
  return code
}

// 获取摄像头图像
Blockly.Blocks['gta_robot_B_get_camera_image'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField('获取摄像头图像')
    this.setStyle('robot_B_camera')
    // this.setPreviousStatement(true, null)
    // this.setNextStatement(true, null)
    this.setOutput(true)
    this.setTooltip(
      '获取当前摄像头的图像，返回网络图片地址。参数：无。返回：网络地址URL'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_get_camera_image'])
  },
}

Blockly.Python['gta_robot_B_get_camera_image'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var code = `${robot}.get_camera_image()`
  return [code, Blockly.Python.ORDER_NONE]
}

/**
 * 技能Skill模块
 * */
// 检测色块：
Blockly.Blocks['gta_robot_B_detect_color_blob'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField('检测色块:  下边界')
    this.appendValueInput('LOW')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 上边界')
    this.appendValueInput('HIGH')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(' 停止时间')
      .appendField(new Blockly.FieldNumber(0, 1), 'timeout')
    this.setStyle('robot_B_skill')
    // this.setPreviousStatement(true, null)
    // this.setNextStatement(true, null)
    this.setOutput(true)
    this.setTooltip(
      '检测图像中是否有指定HSV范围内的色块的线段，如有则返回True 和数组[X1,Y1,X2,Y2]（指代线段起点坐标与终点坐标）。参数：下边界：HSV颜色值，上边界：HSV颜色值，停止：几秒后停止'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_detect_color_blob'])
  },
}

Blockly.Python['gta_robot_B_detect_color_blob'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  let lowColor = Blockly.Python.valueToCode(
    block,
    'LOW',
    Blockly.Python.ORDER_NONE
  ).trim()
  let highColor = Blockly.Python.valueToCode(
    block,
    'HIGH',
    Blockly.Python.ORDER_NONE
  )

  let lowH, lowS, lowV, highH, highS, highV
  lowH = lowS = lowV = highH = highS = highV = 0

  if (lowColor && typeof lowColor == 'string' && lowColor != '...') {
    lowColor = JSON.parse(lowColor)
    lowH = lowColor.h
    lowS = lowColor.s
    lowV = lowColor.v
  }
  if (highColor && typeof highColor == 'string' && highColor != '...') {
    highColor = JSON.parse(highColor)
    highH = highColor.h
    highS = highColor.s
    highV = highColor.v
  }
  var timeout = block.getFieldValue('timeout')
  var code = `${robot}.skill.detect_color_blob(hsv_low=(${lowH}, ${lowS}, ${lowV}),hsv_high=(${highH}, ${highS}, ${highV}),timeout=${timeout})\n`
  return [code, Blockly.Python.ORDER_NONE]

}

// HSV色块：
Blockly.Blocks['gta_robot_hsv'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('HSV色块:  H')
      .appendField(new Blockly.FieldNumber(0, 0, 360, 1), 'h')
      .appendField(' S')
      .appendField(new Blockly.FieldNumber(0, 0, 100, 1), 's')
      .appendField(' V')
      .appendField(new Blockly.FieldNumber(0, 0, 100, 1), 'v')
    this.setInputsInline(true)
    this.setStyle('robot_B_skill')
    this.setOutput(true)
    this.setTooltip(
      'HSV色块,输出hsv颜色值。参数H色调、S饱和度、V明度。输出HSV值'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_hsv'])
  },
}

Blockly.Python['gta_robot_hsv'] = function(block) {
  var h = block.getFieldValue('h')
  var s = block.getFieldValue('s')
  var v = block.getFieldValue('v')
  var code = `{"h":${h},"s":${s},"v":${v}}`
  return [code, Blockly.Python.ORDER_NONE]
}

// 自动巡线
Blockly.Blocks['gta_robot_B_move_along_line'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField('自动巡线')
    this.setStyle('robot_B_skill')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip(
      '自动巡线。参数：无。返回bool :巡线结束返回True，异常返回False'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_move_along_line'])
  },
}

Blockly.Python['gta_robot_B_move_along_line'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  var code = `${robot}.skill.move_along_line()\n`
  return code
}

// 检测图案
Blockly.Blocks['gta_robot_B_detect_pattern'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('检测图案 ')
      .appendField(' 图案')
      .appendField(new Blockly.FieldTextInput('A'), 'pattern')
      .appendField('  ')
      .appendField(new Blockly.FieldNumber(0), 'timeout')
      .appendField('秒后停止')
    this.setStyle('robot_B_skill')
    // this.setPreviousStatement(true, null)
    // this.setNextStatement(true, null)
    this.setOutput(true)
    this.setTooltip(
      "检测图案。参数：a.图案:支持图案'A'-'Z'，'0'~'9',b.几秒后停止。返回bool :检测到指定图案返回True，未检测到返回False"
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_detect_pattern'])
  },
}

Blockly.Python['gta_robot_B_detect_pattern'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  let pattern = block.getFieldValue('pattern')
  let timeout = block.getFieldValue('timeout')
  var code = `${robot}.skill.detect_pattern(id='${pattern}', timeout=${timeout})`
  return [code, Blockly.Python.ORDER_NONE]
}

// 移动至图案（A）前方指定位置X（0）Y（13）
Blockly.Blocks['gta_robot_B_move_to_pattern'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('移动至图案前指定位置 ')
      .appendField(' 图案')
      .appendField(new Blockly.FieldTextInput('A'), 'pattern')
      .appendField('  X')
      .appendField(new Blockly.FieldNumber(30, -30, 30, 1), 'X')
      .appendField('  Y')
      .appendField(new Blockly.FieldNumber(0, -13, 60, 1), 'Y')
    this.setStyle('robot_B_skill')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip(
      "移动至图案前指定位置。参数：a.图案:支持图案'A'-'Z'，'0'~'9',b. X:停止时，图案中心线与机器人中心线左右距离，单位cm,-30~30,整数值；c. Y:停止时，图案处于机器人摄像头平面前方距离,单位cm,-13~60,整数值；d.几秒后停止；返回bool ：成功移动到图案前指定位置返回True，失败返回False"
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_B_move_to_pattern'])
  },
}

Blockly.Python['gta_robot_B_move_to_pattern'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  let pattern = block.getFieldValue('pattern')
  let X = block.getFieldValue('X')
  let Y = block.getFieldValue('Y')
  var code = `${robot}.skill.move_to_pattern(id='${pattern}',x=${X},y=${Y})\n`
  return code
}

// 检测人脸
Blockly.Blocks['gta_robot_B_detect_face'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('检测人脸  ')
      .appendField(new Blockly.FieldNumber(0), 'timeout')
      .appendField('秒后停止')
    this.setStyle('robot_B_skill')
    // this.setPreviousStatement(true, null)
    // this.setNextStatement(true, null)
    this.setOutput(true)
    this.setTooltip('检测人脸。参数：几秒后停止。')
    this.setHelpUrl(Blockly.Msg['gta_robot_B_detect_face'])
  },
}

Blockly.Python['gta_robot_B_detect_face'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  let timeout = block.getFieldValue('timeout')
  var code = `${robot}.skill.detect_face(timeout=${timeout})`
  return [code, Blockly.Python.ORDER_NONE]
}

// 检测二维码，（1）秒后停止
Blockly.Blocks['gta_robot_B_detect_qrcode'] = {
  init: function() {
    this.appendValueInput('ROBOT')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('检测二维码  ')
      .appendField(new Blockly.FieldNumber(0, 0), 'timeout')
      .appendField('秒后停止')
    this.setStyle('robot_B_skill')
    // this.setPreviousStatement(true, null)
    // this.setNextStatement(true, null)
    this.setOutput(true)
    this.setTooltip('检测二维码。参数：几秒后停止。')
    this.setHelpUrl(Blockly.Msg['gta_robot_B_detect_qrcode'])
  },
}

Blockly.Python['gta_robot_B_detect_qrcode'] = function(block) {
  let robot = Blockly.Python.valueToCode(
    block,
    'ROBOT',
    Blockly.Python.ORDER_NONE
  )
  let timeout = block.getFieldValue('timeout')
  var code = `${robot}.skill.detect_qrcode(timeout=${timeout})`
  return [code, Blockly.Python.ORDER_NONE]
}
